import { crud, http } from '../../libs/react-mpk/services';

let service = new crud('/notification');

export const updateNotificationBulk = (query) => {
    return http.get(`/notification/bulk`, query);
};

export default service